import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  vigencia = new Date().getFullYear()-1;
  title = 'Declaración de renta '+this.vigencia;
}
